export const INTEGRATIONS_CONNECT_REQUEST = 'INTEGRATIONS_CONNECT_REQUEST';
export const INTEGRATIONS_CONNECT_FAILED = 'INTEGRATIONS_CONNECT_FAILED';
export const INTEGRATIONS_CONNECT_SUCCEED = 'INTEGRATIONS_CONNECT_SUCCEED';

export const INTEGRATIONS_GET_CONNECTED_REQUEST = 'INTEGRATIONS_GET_CONNECTED_REQUEST';
export const INTEGRATIONS_GET_CONNECTED_ERROR = 'INTEGRATIONS_GET_CONNECTED_ERROR';
export const INTEGRATIONS_GET_CONNECTED_STORE = 'INTEGRATIONS_GET_CONNECTED_STORE';
export const INTEGRATIONS_GET_CONNECTED_ALL_STORE = 'INTEGRATIONS_GET_CONNECTED_ALL_STORE';

export const DISCONNECT_INTEGRATION_REQUEST = 'DISCONNECT_INTEGRATION_REQUEST';
export const DISCONNECT_INTEGRATION_ERROR = 'DISCONNECT_INTEGRATION_ERROR';
export const DISCONNECT_INTEGRATION_STORE = 'DISCONNECT_INTEGRATION_STORE';

export const VERIFY_INTEGRATION_REQUEST = 'VERIFY_INTEGRATION_REQUEST';
export const VERIFY_INTEGRATION_ERROR = 'VERIFY_INTEGRATION_ERROR';
export const VERIFY_INTEGRATION_SUCCESS = 'VERIFY_INTEGRATION_SUCCESS';

export const AUTH_TWITTER_REQUEST = 'AUTH_TWITTER_REQUEST';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';

export const REGISTER_SHOPIFY_REQUEST = 'REGISTER_SHOPIFY_REQUEST';
export const REGISTER_SHOPIFY_SUCCESS = 'REGISTER_SHOPIFY_SUCCESS';
export const REGISTER_SHOPIFY_ERROR = 'REGISTER_SHOPIFY_ERROR';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

// export const USER_SETTINGS_REQUEST = 'USER_SETTINGS_REQUEST';
// export const USER_SETTINGS_ERROR = 'USER_SETTINGS_ERROR';
// export const USER_SETTINGS_STORE = 'USER_SETTINGS_STORE';

export const UNILINK_UPDATE_REQUESTING = 'UNILINK_UPDATE_REQUESTING';

export const UNILINK_GET_DATA_REQUEST = 'UNILINK_GET_DATA_REQUEST';
export const UNILINK_GET_DATA_ERROR = 'UNILINK_GET_DATA_ERROR';
export const UNILINK_GET_DATA_STORE = 'UNILINK_GET_DATA_STORE';
export const UNILINK_UPDATE_USERNAME = 'UNILINK_UPDATE_USERNAME';

export const UNILINK_SET_ACCOUNT_STORE = 'UNILINK_SET_ACCOUNT_STORE';

export const UNILINK_EDIT_BUTTON_LINK_REQUEST = 'UNILINK_EDIT_BUTTON_LINK_REQUEST';
export const UNILINK_EDIT_BUTTON_LINK_ERROR = 'UNILINK_EDIT_BUTTON_LINK_ERROR';
export const UNILINK_EDIT_BUTTON_LINK_STORE = 'UNILINK_EDIT_BUTTON_LINK_STORE';

export const UNILINK_DELETE_BUTTON_LINK_REQUEST = 'UNILINK_DELETE_BUTTON_LINK_REQUEST';
export const UNILINK_DELETE_BUTTON_LINK_ERROR = 'UNILINK_DELETE_BUTTON_LINK_ERROR';
export const UNILINK_DELETE_BUTTON_LINK_STORE = 'UNILINK_DELETE_BUTTON_LINK_STORE';

export const UNILINK_SORT_BUTTON_LINK_REQUEST = 'UNILINK_SORT_BUTTON_LINK_REQUEST';
export const UNILINK_SORT_BUTTON_LINK_ERROR = 'UNILINK_SORT_BUTTON_LINK_ERROR';
export const UNILINK_SORT_BUTTON_LINK_STORE = 'UNILINK_SORT_BUTTON_LINK_STORE';

export const UNILINK_EDIT_MEDIA_REQUEST = 'UNILINK_EDIT_MEDIA_REQUEST';
export const UNILINK_EDIT_MEDIA_ERROR = 'UNILINK_EDIT_MEDIA_ERROR';
export const UNILINK_EDIT_MEDIA_STORE = 'UNILINK_EDIT_MEDIA_STORE';

export const UNILINK_DELETE_MEDIA_REQUEST = 'UNILINK_DELETE_MEDIA_REQUEST';
export const UNILINK_DELETE_MEDIA_ERROR = 'UNILINK_DELETE_MEDIA_ERROR';
export const UNILINK_DELETE_MEDIA_STORE = 'UNILINK_DELETE_MEDIA_STORE';

export const UNILINK_DELETE_LABEL_REQUEST = 'UNILINK_DELETE_LABEL_REQUEST';
export const UNILINK_DELETE_LABEL_ERROR = 'UNILINK_DELETE_MEDIA_ERROR';
export const UNILINK_DELETE_LABEL_STORE = 'UNILINK_DELETE_LABEL_STORE';

export const UNILINK_EDIT_HEADER_REQUEST = 'UNILINK_EDIT_HEADER_REQUEST';
export const UNILINK_EDIT_HEADER_ERROR = 'UNILINK_EDIT_HEADER_ERROR';
export const UNILINK_EDIT_HEADER_STORE = 'UNILINK_EDIT_HEADER_STORE';

export const UNILINK_REFRESH_REQUEST = 'UNILINK_REFRESH_REQUEST';
export const UNILINK_REFRESH_ERROR = 'UNILINK_REFRESH_ERROR';
export const UNILINK_REFRESH_STORE = 'UNILINK_REFRESH_STORE';

export const UNILINK_UPLOAD_REQUEST = 'UNILINK_UPLOAD_REQUEST';
export const UNILINK_UPLOAD_ERROR = 'UNILINK_UPLOAD_ERROR';
export const UNILINK_UPLOAD_SUCCESS = 'UNILINK_UPLOAD_SUCCESS';

export const UNILINK_ADD_TIKTOK_REQUEST = 'UNILINK_AD_TIKTOK_REQUEST';
export const UNILINK_ADD_TIKTOK_ERROR = 'UNILINK_AD_TIKTOK_ERROR';
export const UNILINK_ADD_TIKTOK_SUCCESS = 'UNILINK_AD_TIKTOK_SUCCESS';

export const UNILINK_DELETE_TIKTOK_REQUEST = 'UNILINK_DELETE_TIKTOK_REQUEST';
export const UNILINK_DELETE_TIKTOK_ERROR = 'UNILINK_DELETE_TIKTOK_ERROR';
export const UNILINK_DELETE_TIKTOK_STORE = 'UNILINK_DELETE_TIKTOK_STORE';

export const UNILINK_EDIT_TIKTOK_TAG_REQUEST = 'UNILINK_EDIT_TIKTOK_TAG_REQUEST';
export const UNILINK_EDIT_TIKTOK_TAG_ERROR = 'UNILINK_EDIT_TIKTOK_TAG_ERROR';
export const UNILINK_EDIT_TIKTOK_TAG_STORE = 'UNILINK_EDIT_TIKTOK_TAG_STORE';

export const UNILINK_DELETE_TIKTOK_TAG_REQUEST = 'UNILINK_DELETE_TIKTOK_TAG_REQUEST';
export const UNILINK_DELETE_TIKTOK_TAG_ERROR = 'UNILINK_DELETE_TIKTOK_TAG_ERROR';
export const UNILINK_DELETE_TIKTOK_TAG_STORE = 'UNILINK_DELETE_TIKTOK_TAG_STORE';

export const UNILINK_SETUP_STEPS_REQUEST = 'UNILINK_SETUP_STEPS_REQUEST';
export const UNILINK_SETUP_STEPS_ERROR = 'UNILINK_SETUP_STEPS_ERROR';
export const UNILINK_SETUP_STEPS_STORE = 'UNILINK_SETUP_STEPS_STORE';

export const UNILINK_SETUP_STEPS_WIZARD_REQUEST = 'UNILINK_SETUP_STEPS_WIZARD_REQUEST';
export const UNILINK_SETUP_STEPS_WIZARD_ERROR = 'UNILINK_SETUP_STEPS_WIZARD_ERROR';
export const UNILINK_SETUP_STEPS_WIZARD_STORE = 'UNILINK_SETUP_STEPS_WIZARD_STORE';

export const UNILINK_SETUP_STEPS_START_REQUEST = 'UNILINK_SETUP_STEPS_START_REQUEST';
export const UNILINK_SETUP_STEPS_START_ERROR = 'UNILINK_SETUP_STEPS_START_ERROR';
export const UNILINK_SETUP_STEPS_START_STORE = 'UNILINK_SETUP_STEPS_START_STORE';

export const UNILINK_SETUP_STEPS_SKIP_REQUEST = 'UNILINK_SETUP_STEPS_SKIP_REQUEST';
export const UNILINK_SETUP_STEPS_SKIP_ERROR = 'UNILINK_SETUP_STEPS_SKIP_ERROR';
export const UNILINK_SETUP_STEPS_SKIP_STORE = 'UNILINK_SETUP_STEPS_SKIP_STORE';

export const UNILINK_GET_TEMPLATES_REQUEST = 'UNILINK_GET_TEMPLATES_REQUEST';
export const UNILINK_GET_TEMPLATES_ERROR = 'UNILINK_GET_TEMPLATES_ERROR';
export const UNILINK_GET_TEMPLATES_STORE = 'UNILINK_GET_TEMPLATES_STORE';

export const UNILINK_CLEAN_LEADS_REQUEST = 'UNILINK_CLEAN_LEADS_REQUEST';
export const UNILINK_CLEAN_LEADS_ERROR = 'UNILINK_CLEAN_LEADS_ERROR';
export const UNILINK_CLEAN_LEADS_STORE = 'UNILINK_CLEAN_LEADS_STORE';

export const UNILINK_CLEAN_LEADS_NOTIFICATIONS_REQUEST = 'UNILINK_CLEAN_LEADS_NOTIFICATIONS_REQUEST';
export const UNILINK_CLEAN_LEADS_NOTIFICATIONS_ERROR = 'UNILINK_CLEAN_LEADS_NOTIFICATIONS_ERROR';
export const UNILINK_CLEAN_LEADS_NOTIFICATIONS_STORE = 'UNILINK_CLEAN_LEADS_NOTIFICATIONS_STORE';

export const UNILINK_GET_ANALYTICS_REQUEST = 'UNILINK_GET_ANALYTICS_REQUEST';
export const UNILINK_GET_ANALYTICS_ERROR = 'UNILINK_GET_ANALYTICS_ERROR';
export const UNILINK_GET_ANALYTICS_STORE = 'UNILINK_GET_ANALYTICS_STORE';

export const UNILINK_CLEAN_ANALYTICS_REQUEST = 'UNILINK_CLEAN_ANALYTICS_REQUEST';
export const UNILINK_CLEAN_ANALYTICS_ERROR = 'UNILINK_CLEAN_ANALYTICS_ERROR';
export const UNILINK_CLEAN_ANALYTICS_STORE = 'UNILINK_CLEAN_ANALYTICS_STORE';

export const UNILINK_UPLOAD_GIF_REQUEST = 'UNILINK_UPLOAD_GIF_REQUEST';
export const UNILINK_UPLOAD_GIF_ERROR = 'UNILINK_UPLOAD_GIF_ERROR';
export const UNILINK_UPLOAD_GIF_SUCCESS = 'UNILINK_UPLOAD_GIF_SUCCESS';

export const UNILINK_GET_ANALYTICS_OVERTIME_REQUEST = 'UNILINK_GET_ANALYTICS_OVERTIME_REQUEST';
export const UNILINK_GET_ANALYTICS_OVERTIME_ERROR = 'UNILINK_GET_ANALYTICS_OVERTIME_ERROR';
export const UNILINK_GET_ANALYTICS_OVERTIME_STORE = 'UNILINK_GET_ANALYTICS_OVERTIME_STORE';

export const UNILINK_GET_ANALYTICS_COUNTRIES_REQUEST = 'UNILINK_GET_ANALYTICS_COUNTRIES_REQUEST';
export const UNILINK_GET_ANALYTICS_COUNTRIES_ERROR = 'UNILINK_GET_ANALYTICS_COUNTRIES_ERROR';
export const UNILINK_GET_ANALYTICS_COUNTRIES_STORE = 'UNILINK_GET_ANALYTICS_COUNTRIES_STORE';

export const UNILINK_GET_LEADS_REQUEST = 'UNILINK_GET_LEADS_REQUEST';
export const UNILINK_GET_LEADS_ERROR = 'UNILINK_GET_LEADS_ERROR';
export const UNILINK_GET_LEADS_STORE = 'UNILINK_GET_LEADS_STORE';

export const UNILINK_EDIT_CATEGORIES_REQUEST = 'UNILINK_EDIT_CATEGORIES_REQUEST';
export const UNILINK_EDIT_CATEGORIES_ERROR = 'UNILINK_EDIT_CATEGORIES_ERROR';
export const UNILINK_EDIT_CATEGORIES_STORE = 'UNILINK_EDIT_CATEGORIES_STORE';

export const UNILINK_EDIT_PROPERTIES_REQUEST = 'UNILINK_EDIT_PROPERTIES_REQUEST';
export const UNILINK_EDIT_PROPERTIES_ERROR = 'UNILINK_EDIT_PROPERTIES_ERROR';
export const UNILINK_EDIT_PROPERTIES_STORE = 'UNILINK_EDIT_PROPERTIES_STORE';

export const UNILINK_DELETE_PROPERTIES_REQUEST = 'UNILINK_DELETE_PROPERTIES_REQUEST';
export const UNILINK_DELETE_PROPERTIES_ERROR = 'UNILINK_DELETE_PROPERTIES_ERROR';
export const UNILINK_DELETE_PROPERTIES_STORE = 'UNILINK_DELETE_PROPERTIES_STORE';

export const UNILINK_EDIT_CUSTOM_MEDIA_REQUEST = 'UNILINK_EDIT_CUSTOM_MEDIA_REQUEST';
export const UNILINK_EDIT_CUSTOM_MEDIA_ERROR = 'UNILINK_EDIT_CUSTOM_MEDIA_ERROR';
export const UNILINK_EDIT_CUSTOM_MEDIA_STORE = 'UNILINK_EDIT_CUSTOM_MEDIA_STORE';

export const UNILINK_DELETE_CUSTOM_MEDIA_REQUEST = 'UNILINK_DELETE_CUSTOM_MEDIA_REQUEST';
export const UNILINK_DELETE_CUSTOM_MEDIA_ERROR = 'UNILINK_DELETE_CUSTOM_MEDIA_ERROR';
export const UNILINK_DELETE_CUSTOM_MEDIA_STORE = 'UNILINK_DELETE_CUSTOM_MEDIA_STORE';

export const UNILINK_EDIT_SUBPAGE_REQUEST = 'UNILINK_EDIT_SUBPAGE_REQUEST';
export const UNILINK_EDIT_SUBPAGE_ERROR = 'UNILINK_EDIT_SUBPAGE_ERROR';
export const UNILINK_EDIT_SUBPAGE_STORE = 'UNILINK_EDIT_SUBPAGE_STORE';

export const UNILINK_DELETE_SUBPAGE_REQUEST = 'UNILINK_DELETE_SUBPAGE_REQUEST';
export const UNILINK_DELETE_SUBPAGE_ERROR = 'UNILINK_DELETE_SUBPAGE_ERROR';
export const UNILINK_DELETE_SUBPAGE_STORE = 'UNILINK_DELETE_SUBPAGE_STORE';

export const UNILINK_EDIT_SUBPAGE_BIO_REQUEST = 'UNILINK_EDIT_SUBPAGE_BIO_REQUEST';
export const UNILINK_EDIT_SUBPAGE_BIO_ERROR = 'UNILINK_EDIT_SUBPAGE_BIO_ERROR';
export const UNILINK_EDIT_SUBPAGE_BIO_STORE = 'UNILINK_EDIT_SUBPAGE_BIO_STORE';

export const UNILINK_EDIT_SUBPAGE_FORM_REQUEST = 'UNILINK_EDIT_SUBPAGE_FORM_REQUEST';
export const UNILINK_EDIT_SUBPAGE_FORM_ERROR = 'UNILINK_EDIT_SUBPAGE_FORM_ERROR';
export const UNILINK_EDIT_SUBPAGE_FORM_STORE = 'UNILINK_EDIT_SUBPAGE_FORM_STORE';

export const UNILINK_EDIT_SUBPAGE_EMAIL_REQUEST = 'UNILINK_EDIT_SUBPAGE_EMAIL_REQUEST';
export const UNILINK_EDIT_SUBPAGE_EMAIL_ERROR = 'UNILINK_EDIT_SUBPAGE_EMAIL_ERROR';
export const UNILINK_EDIT_SUBPAGE_EMAIL_STORE = 'UNILINK_EDIT_SUBPAGE_EMAIL_STORE';

export const STEPS_OPEN_STEP_REQUEST = 'STEPS_OPEN_STEP_REQUEST';
export const STEPS_SET_COMPLETED_REQUEST = 'STEPS_SET_COMPLETED_REQUEST';
export const STEPS_SET_CURRENT_STEP = 'STEPS_SET_CURRENT_STEP';
export const STEPS_SET_COMPLETED_STEP = 'STEPS_SET_COMPLETED_STEP';

export const INSTAGRAM_ADD_ACCOUNT_REQUEST = 'INSTAGRAM_ADD_ACCOUNT_REQUEST';
export const INSTAGRAM_ADD_ACCOUNT_ERROR = 'INSTAGRAM_ADD_ACCOUNT_ERROR';
export const INSTAGRAM_ADD_ACCOUNT_SUCCESS = 'INSTAGRAM_ADD_ACCOUNT_SUCCESS';

export const INSTAGRAM_STORE_ACCOUNT_ID = 'INSTAGRAM_STORE_ACCOUNT_ID';
export const INSTAGRAM_ACCOUNT_RESET = 'INSTAGRAM_ACCOUNT_RESET';

export const INSTAGRAM_VERIFY_ACCOUNT_REQUEST = 'INSTAGRAM_VERIFY_ACCOUNT_REQUEST';
export const INSTAGRAM_VERIFY_ACCOUNT_ERROR = 'INSTAGRAM_VERIFY_ACCOUNT_ERROR';
export const INSTAGRAM_VERIFY_ACCOUNT_SUCCESS = 'INSTAGRAM_VERIFY_ACCOUNT_SUCCESS';

export const INSTAGRAM_CHECK_CODE_REQUEST = 'INSTAGRAM_CHECK_CODE_REQUEST';
export const INSTAGRAM_CHECK_CODE_ERROR = 'INSTAGRAM_CHECK_CODE_ERROR';
export const INSTAGRAM_CHECK_CODE_SUCCESS = 'INSTAGRAM_CHECK_CODE_SUCCESS';

export const CAMPAIGN_SET_NAME_REQUEST = 'CAMPAIGN_SET_NAME_REQUEST';
export const CAMPAIGN_SET_NAME_UPDATE = 'CAMPAIGN_SET_NAME_UPDATE';

export const CAMPAIGN_ENABLE_INTEGRATION_REQUEST = 'CAMPAIGN_ENABLE_INTEGRATION_REQUEST';
export const CAMPAIGN_ENABLE_INTEGRATION_UPDATE = 'CAMPAIGN_ENABLE_INTEGRATION_UPDATE';

export const CAMPAIGN_CREATE_REQUEST = 'CAMPAIGN_CREATE_REQUEST';
export const CAMPAIGN_CREATE_ERROR = 'CAMPAIGN_CREATE_ERROR';
export const CAMPAIGN_CREATE_SUCCESS = 'CAMPAIGN_CREATE_SUCCESS';

export const CAMPAIGN_REMOVE_REQUEST = 'CAMPAIGN_REMOVE_REQUEST';
export const CAMPAIGN_REMOVE_ERROR = 'CAMPAIGN_REMOVE_ERROR';
export const CAMPAIGN_REMOVE_SUCCESS = 'CAMPAIGN_REMOVE_SUCCESS';

export const CAMPAIGN_RESET_REQUEST = 'CAMPAIGN_RESET_REQUEST';
export const CAMPAIGN_RESET_STATE = 'CAMPAIGN_RESET_STATE';

export const POST_CREATE_REQUEST = 'POST_CREATE_REQUEST';
export const POST_CREATE_ERROR = 'POST_CREATE_ERROR';
export const POST_CREATE_SUCCESS = 'POST_CREATE_SUCCESS';

export const POST_RESET_STATE = 'POST_RESET_STATE';

export const UPLOAD_REQUEST = 'UPLOAD_REQUEST';
export const UPLOAD_ERROR = 'UPLOAD_ERROR';
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';

export const DELETE_MEDIA_REQUEST = 'DELETE_MEDIA_REQUEST';

export const WIZARD_UPDATE_ACTIVE_CUSTOMS = 'WIZARD_UPDATE_ACTIVE_CUSTOMS';

export const WIZARD_STORE_CUSTOMS = 'WIZARD_STORE_CUSTOMS';
export const WIZARD_STORE_SCHEDULE_DATE = 'WIZARD_STORE_SCHEDULE_DATE';
export const WIZARD_STORE_TIMEZONE = 'WIZARD_STORE_TIMEZONE';
export const WIZARD_ADD_CUSTOMS_FILES = 'WIZARD_ADD_CUSTOMS_FILE';
export const WIZARD_REMOVE_CUSTOMS_FILE = 'WIZARD_REMOVE_CUSTOMS_FILE';
export const WIZARD_SET_CUSTOMS_TEXT = 'WIZARD_SET_CUSTOMS_TEXT';
export const WIZARD_SET_CUSTOMS_SOCIAL_PAGE = 'WIZARD_SET_CUSTOMS_SOCIAL_PAGE';

export const WIZARD_RESET_STATE = 'WIZARD_RESET_STATE';

export const CAMPAIGN_PUBLISH_REQUEST = 'CAMPAIGN_PUBLISH_REQUEST';
export const CAMPAIGN_PUBLISH_ERROR = 'CAMPAIGN_PUBLISH_ERROR';
export const CAMPAIGN_PUBLISH_SUCCESS = 'CAMPAIGN_PUBLISH_SUCCESS';

export const WIZARD_SET_TEXT_BODY_UPDATE = 'WIZARD_SET_TEXT_BODY_UPDATE';

export const WIZARD_APPEND_FILES = 'WIZARD_APPEND_FILES';
export const WIZARD_REMOVE_FILE = 'WIZARD_REMOVE_FILE';

export const CAMPAIGNS_ADD_NEW_REQUEST = 'CAMPAIGNS_ADD_NEW_REQUEST';
export const CAMPAIGNS_ADD_NEW_ERROR = 'CAMPAIGNS_ADD_NEW_ERROR';
export const CAMPAIGNS_ADD_NEW_SUCCESS = 'CAMPAIGNS_ADD_NEW_SUCCESS';

export const CAMPAIGNS_GET_LIST_REQUEST = 'CAMPAIGNS_GET_LIST_REQUEST';
export const CAMPAIGNS_GET_LIST_ERROR = 'CAMPAIGNS_GET_LIST_ERROR';
export const CAMPAIGNS_GET_LIST_STORE = 'CAMPAIGNS_GET_LIST_STORE';

export const CAMPAIGNS_LOAD_MORE_REQUEST = 'CAMPAIGNS_LOAD_MORE_REQUEST';
export const CAMPAIGNS_LOAD_MORE_ERROR = 'CAMPAIGNS_LOAD_MORE_ERROR';
export const CAMPAIGNS_LOAD_MORE_APPEND = 'CAMPAIGNS_LOAD_MORE_APPEND';

export const CAMPAIGNS_GET_SINGLE_REQUEST = 'CAMPAIGNS_GET_SINGLE_REQUEST';
export const CAMPAIGNS_GET_SINGLE_ERROR = 'CAMPAIGNS_GET_SINGLE_ERROR';
export const CAMPAIGNS_GET_SINGLE_STORE = 'CAMPAIGNS_GET_SINGLE_STORE';

export const CAMPAIGNS_REMOVE_FROM_LIST = 'CAMPAIGNS_REMOVE_FROM_LIST';

export const CAMPAIGNS_CONVERT_EMAIL_REQUEST = 'CAMPAIGNS_CONVERT_EMAIL_REQUEST';
export const CAMPAIGNS_CONVERT_EMAIL_ERROR = 'CAMPAIGNS_CONVERT_EMAIL_ERROR';
export const CAMPAIGNS_CONVERT_EMAIL_STORE = 'CAMPAIGNS_CONVERT_EMAIL_STORE';

export const SOCIAL_PAGES_GET_LIST_REQUEST = 'SOCIAL_PAGES_GET_LIST_REQUEST';
export const SOCIAL_PAGES_GET_LIST_ERROR = 'SOCIAL_PAGES_GET_LIST_ERROR';
export const SOCIAL_PAGES_GET_LIST_STORE = 'SOCIAL_PAGES_GET_LIST_STORE';

export const USER_SETTINGS_REQUEST = 'USER_SETTINGS_REQUEST';
export const USER_SETTINGS_ERROR = 'USER_SETTINGS_ERROR';
export const USER_SETTINGS_STORE = 'USER_SETTINGS_STORE';

export const PAYMENT_CANCEL_SUBSCRIPTION_REQUEST = 'PAYMENT_CANCEL_SUBSCRIPTION_REQUEST';
export const PAYMENT_CANCEL_SUBSCRIPTION_ERROR = 'PAYMENT_CANCEL_SUBSCRIPTION_ERROR';
export const PAYMENT_CANCEL_SUBSCRIPTION_SUCCESS = 'PAYMENT_CANCEL_SUBSCRIPTION_SUCCESS';

export const PAYMENT_BUY_SUBSCRIPTION_REQUEST = 'PAYMENT_BUY_SUBSCRIPTION_REQUEST';
export const PAYMENT_BUY_SUBSCRIPTION_ERROR = 'PAYMENT_BUY_SUBSCRIPTION_ERROR';
export const PAYMENT_BUY_SUBSCRIPTION_SUCCESS = 'PAYMENT_BUY_SUBSCRIPTION_SUCCESS';
export const PAYMENT_RESET_STATE = 'PAYMENT_RESET_STATE';
export const SET_USER_IS_A_PUBLISH = 'SET_USER_IS_A_PUBLISH';
export const SET_REQUESTING = 'SET_REQUESTING';
export const WIZARD_SET_FILES = 'WIZARD_SET_FILES';
export const WIZARD_SET_STORE_CUSTOMS = 'WIZARD_SET_STORE_CUSTOMS';
export const SET_IS_A_DRAFT = 'SET_IS_A_DRAFT';
export const SET_STORE_POSTS = 'SET_STORE_POSTS';
